import React from 'react';
import SvgIcon from "../svg-icon/SvgIcon";

export const BreakArrowIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 31.104 18.537">
      <path id="Path_731" data-name="Path 731"
            d="M210.709,295h12.567m0,0v12.567m0-12.567-12.567,12.567-6.283-6.283L195,310.709"
            transform="translate(-193.586 -293.586)" fill="none" stroke="#029c0d" strokeLinecap="round"
            strokeLinejoin="round" strokeWidth="2"/>
    </SvgIcon>
  );
};

BreakArrowIcon.propTypes = {}

BreakArrowIcon.defaultProps = {}

export default BreakArrowIcon;
